module.exports = __webpack_public_path__ + "static/media/avenger-logo.dbd51e21.png";